import { call, put, takeLatest , select } from 'redux-saga/effects';

import ApiRouts from '../../api/routes';
import {GET} from "../../api";
import {
   FETCH_TOTAL_COUNT_LIST, SET_TOTAL_COUNT_LIST
} from "../actions";





export function* FetchTotalCountSaga() {


    try {


        const response = yield call(GET, `${ApiRouts.API_TOTAL_COUNT_LIST}` , {});

        if (response) {

            yield put({
                type:SET_TOTAL_COUNT_LIST,
                payload:response.data.data
            });
        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        // yield put(setError(error.message));  // Set error if something goes wrong
        // yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* totalCountSaga() {
    yield takeLatest(FETCH_TOTAL_COUNT_LIST, FetchTotalCountSaga);
    // yield takeLatest(SET_LATEST_VERSION, setLatestVersion);
}

export default totalCountSaga;
